import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from './HeaderSubmission.module.css'
import ForwardLessonBtn from "../../MaterialLibrary/ForwardLessonBtn";
import { ObjectTypeEnum, ObjectTypeNamesEnum } from "../../../../models/ObjectTypeEnum";
import AttachmentsIcon from '../../../../assests/assessments/attachments.png';
import MessagesIcon from '../../../../assests/assessments/messages.png';
import forwardIcon from '../../../../assests/toc/forward.png';
import feedbackOpenIcon from '../../../../assests/submission/feedbackOpenIcon.png';
import feedbackCloseIcon from '../../../../assests/submission/feedbackCloseIcon.png';
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { projectsApi, submissionsApi } from "../../../../utils";
import ToastMessage from "../../../UI/ToastMessage";
import { onKeyDown } from "../../../../service";
import DynamicScoreIndicators from "../DynamicScoreIndicators/DynamicScoreIndicators";
import LeftIcon from '../../../../assests/assessments/left.png'
import SelectArrowIcon from '../../../../assests/assessments/select-arrow.png'
import TasksIcon from '../../../../assests/assessments/tasks.png'
import * as PathRouter from '../../../../models/PathRoute';
import { useNavigate, useParams } from "react-router-dom";
import AttachmentsPopup from "../DynamicScoreIndicators/AttachmentsPopup/AttachmentsPopup";
import StatusBar from "../../../lms-shared/StatusBar/StatusBar";
import * as SubmissionStatus from "../../../lms-shared/models/SubmissionStatus";
import Team from "../../../lms-shared/Team/Team";
import { SourceTypeTextEnum } from "../../../../models/SourceTypeEnum";
import { ActivityTypeEnumText } from "../../../../models/ActivityTypeEnum";

const HeaderSubmission = ({ data, setData }) => {

    const { texts, direction } = useSelector(state => state.translate);
    const { applicationId, homeUrl } = useSelector(state => state.application);
    const { courses } = useSelector(state => state.courses);
    const { filteredAssessmentsList } = useSelector(state => state.filteredAssessments);

    const dispatch = useDispatch();

    const { id } = useParams();

    const [message, setMessage] = useState()
    const [showAttachments, setShowAttachments] = useState(false)
    const [showIndicator, setShowIndicator] = useState(false)
    const [allAssessments, setAllAssessments] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (filteredAssessmentsList) {
            mapAssessments(filteredAssessmentsList);
        }
        else {
            fetchAssessments();
        }
    }, [])

    async function fetchAssessments() {
        const submissionsRangeFilter = {
            studyGroupId: id,
            activityType: ActivityTypeEnumText.Final,
            sourceTypes: [SourceTypeTextEnum.IDE],
            allParticipants: true,
        }
        submissionsApi.submissionsFilterRangePost({ submissionsRangeFilter }, (error, resdata, response) => {
            if (error) {
                setAllAssessments([]);
                dispatch(throwApiError({ userMessage: texts.submissionsFilterError, error: error, statusCode: response?.statusCode, message: "submissionsFilterRangePost " + error.message, level: 1, component: "HeaderSubmission", line: 66 }));
            }
            else {
                mapAssessments(resdata);
            }
        })
    }

    const mapAssessments = (resdata) => {
        const newallAssessments = [];
        resdata.map(d => {
            if (data.submissionStatusId === SubmissionStatus.completed && d.submissionStatusId === SubmissionStatus.completed) {
                newallAssessments.push(d)
            }
            if ((data.submissionStatusId === SubmissionStatus.started || data.submissionStatusId === SubmissionStatus.notStarted) && (d.submissionStatusId === SubmissionStatus.started || d.submissionStatusId === SubmissionStatus.notStarted)) {
                newallAssessments.push(d)
            }
            if (data.submissionStatusId !== SubmissionStatus.completed && d.submissionStatusId !== SubmissionStatus.completed && data.submissionStatusId !== SubmissionStatus.started && d.submissionStatusId !== SubmissionStatus.started && data.submissionStatusId !== SubmissionStatus.notStarted && d.submissionStatusId !== SubmissionStatus.notStarted) {
                newallAssessments.push(d)
            }
            if (typeof (d.assessmentContentData) === 'string') {
                d.assessmentContentData = JSON.parse(d.assessmentContentData)
            }
        })
        setAllAssessments(newallAssessments)
    }


    const sort = (sortBy) => {
        if (sortBy == 'firstName') {
            setAllAssessments([...allAssessments].sort((a, b) => a.submittedByUser.firstName.localeCompare(b.submittedByUser.firstName)));
        }
        else {
            setAllAssessments([...allAssessments].sort((a, b) => a[sortBy].localeCompare(b[sortBy])));
        }
    }

    function copyProject(e) {
        e.stopPropagation()
        const opts = {
            id: data.solution,
            file: null,
            refObjectType: ObjectTypeNamesEnum.Application,
            refObjectId: applicationId
        }

        projectsApi.projectsDuplicatePost(opts, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageContentProjectsDuplicate, error: error, statusCode: response?.statusCode, message: "projectsDuplicatePost " + error.message, level: 2, component: 'HeaderSubmission', line: 85 }))
            }
            else {
                setMessage(<ToastMessage text={texts.MessageContentSuccessCopyProjectStatus} color="green" close={() => setMessage(null)} />)
            }
        })
    }

    const goBackToAssessments = () => {
        navigate(`${homeUrl}/${PathRouter.LEARNING_TRACKING}/${id}/${PathRouter.ASSESSMENTS}/all`)
    }

    const openIndicator = () => {
        setShowIndicator(showIndicator => !showIndicator);
    }

    const getTitle = () => {
        switch (data.submissionStatusId) {
            case SubmissionStatus.started:
            case SubmissionStatus.notStarted:
                return texts.QuestionsFromStudents;
            case SubmissionStatus.completed: return texts.CheckedAssignments;
            default: return texts.assessmentsToCheck;
        }
    }

    const markAssessmentAsChecked = (assessmentId) => {
        setAllAssessments(prevAllAssessments => {
            let newAllAssessments = [...prevAllAssessments];
            const index = newAllAssessments.findIndex(x => x.id === assessmentId)
            newAllAssessments[index] = { ...newAllAssessments[index], checked: true };
            return newAllAssessments;
        })
    }

    const tasksNum = allAssessments?.reduce((acc, o) => acc + parseInt(o.checked ? 0 : 1), 0)

    return (
        <>
            {data && <div className={`${classes[direction]} ${classes.HeaderSubmissionContainer}`}>
                <div className={classes.BackToAssessments}>
                    <img src={LeftIcon} onClick={goBackToAssessments} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, goBackToAssessments)} />
                    <div>{texts.assessments}</div>
                </div>
                <div className={classes.AssessmentsToCheck} onClick={openIndicator} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, openIndicator)}>
                    <img src={TasksIcon} />
                    <div className={classes.TasksNum}>{tasksNum}</div>
                    <div className={classes.AssessmentsToCheckText}>{getTitle()}</div>
                    <img src={SelectArrowIcon} />
                </div>
                <div className={classes.nameContainer} onClick={openIndicator} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, openIndicator)}>
                    <div>{data.assessmentName}</div>
                    <div>&nbsp;&nbsp;/&nbsp;&nbsp;</div>
                    <div>{courses?.find(x => x.id === id)?.name}</div>
                </div>

                {data.submittedByUser?.isGroup ?
                    <Team data={data.submittedByUser} /> :
                    <div>{data.submittedByUser?.firstName} {data.submittedByUser?.lastName}</div>
                }

                <StatusBar currentStatus={data.submissionStatusId} submittedDate={data.submittedDate} assessmentDueDate={data.assessmentDueDate} />
                <div>
                    <div className={classes.Icons}>
                        {<div className={classes.Messages} onClick={openIndicator} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, openIndicator)} title={texts.newMessages}>
                            <img className={classes.AttachmentsImg} src={MessagesIcon} alt="Attachments" />
                            {data.pendingMessagesCount > 0 && <div className={classes.AttachmentsNum}>{data.pendingMessagesCount}</div>}
                        </div>}
                        {<div className={classes.Attachments} onClick={() => setShowAttachments(showAttachments => !showAttachments)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowAttachments(showAttachments => !showAttachments))} title={texts.attachmentFiles}>
                            <img className={classes.AttachmentsImg} src={AttachmentsIcon} alt="Attachments" />
                            {data.contentData?.Attachments?.length && <div className={classes.AttachmentsNum}>{data.contentData?.Attachments?.length}</div>}
                        </div>}
                        {/* <div className={classes.BlackIcon}><img src={copyIcon} onClick={copyProject} /></div> */}
                        <div className={classes.BlackIcon} title={texts.sendProject}>
                            <ForwardLessonBtn ViewText={texts.copyLinkToCode} setMessage={setMessage} data={{ id: data.solution, name: data.assessmentName }} type={ObjectTypeEnum.Project} icon={forwardIcon} />
                        </div>
                    </div>
                    {!showIndicator &&
                        <div className={classes.ArrowBtnContainer} onClick={openIndicator} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, openIndicator)}>
                            <img src={feedbackOpenIcon} />
                        </div>
                    }
                    <div className={`${classes.Indicator} ${showIndicator ? classes.IndicatorVisible : ''}`}>
                        <DynamicScoreIndicators data={data} setData={setData} allAssessments={allAssessments} sort={sort} markAssessmentAsChecked={markAssessmentAsChecked} />
                        <img className={classes.ArrowBtnRotate} src={feedbackCloseIcon} onClick={openIndicator} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, openIndicator)} />
                    </div>
                </div>
                {showAttachments && <AttachmentsPopup data={data} setShowAttachments={setShowAttachments} />}
            </div>}
            {message}
        </>
    )
}

export default HeaderSubmission